import React from "react";
import { createPortal } from "react-dom";
import { LEVERAGE_MIN, LEVERAGE_MAX } from "../../constants";

/**
 * Leverage Selection Modal
 */
export function LeverageModal({
  isOpen,
  currentLeverage: _currentLeverage,
  tempLeverage,
  maxRatio,
  onLeverageChange,
  onConfirm,
  onCancel,
  onOverlayClick = () => {},
}: {
  isOpen: boolean;
  currentLeverage: number;
  tempLeverage: number;
  maxRatio: string;
  onLeverageChange: (leverage: number) => void;
  onConfirm: () => void;
  onCancel: () => void;
  /** Called when the modal overlay (backdrop) is clicked. Default: no-op. */
  onOverlayClick?: () => void;
}): JSX.Element | null {
  if (!isOpen) return null;

  const modalContent = (
    <div className="modal-overlay" onClick={onOverlayClick}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Select Leverage</h3>
        </div>
        <div className="modal-body">
          {/* Maximum Ratio Display */}
          <div className="leverage-max-ratio">
            <div className="leverage-max-ratio-label">Maximum Ratio</div>
            <div className="leverage-max-ratio-value">{maxRatio}x</div>
          </div>

          {/* Leverage Slider */}
          <div className="leverage-slider-container">
            <input
              type="range"
              min={LEVERAGE_MIN}
              max={LEVERAGE_MAX}
              value={tempLeverage}
              onChange={(e) => onLeverageChange(parseInt(e.target.value))}
              className="filled-slider"
              style={
                {
                  "--slider-progress": `${((tempLeverage - LEVERAGE_MIN) / (LEVERAGE_MAX - LEVERAGE_MIN)) * 100}%`,
                } as React.CSSProperties
              }
            />
            <div className="leverage-slider-labels">
              <span>1x</span>
              <span className="leverage-current-value">{tempLeverage}x</span>
              <span>100x</span>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button onClick={onCancel} className="btn btn-secondary">
            Cancel
          </button>
          <button onClick={onConfirm} className="btn btn-primary">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );

  // Use portal to render modal at document body level
  return typeof document !== "undefined"
    ? createPortal(modalContent, document.body)
    : null;
}
